import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { CONSTANTS, EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
@Component({
	selector: 'app-product-lift-table',
	templateUrl: './product-lift-table.component.html',
	styleUrls: ['./product-lift-table.component.css']
})
export class ProductLiftTableComponent implements OnInit, WidgetCore, OnDestroy {
	public placeholderimage: string;
	public key: string;
	public campaignsList = [];
	public timeserieskey: string;
	public sectionclass: string;
	public campaignCarouselItem: any;
	public showLoad = true;
	getDisplayIndex: any;
	public colorPalette: ColorPalette;
	public reloadSubscription;
	public widgetDataSubscription;
	public widgetTimelineSubscription;

	constructor(
		private analyticsService: AnalyticsService,
		private colorUtilityService: ColorUtilityService,
		private analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.requestData();
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		if (this.widgetTimelineSubscription) {
			this.widgetTimelineSubscription.unsubscribe();
		}
	}

	requestData() {
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			if (res.success) {
				this.campaignsList = res.data;
			}
			this.widgetTimelineSubscription = this.analyticsService
				.processWidgetRequest(this.timeserieskey)
				.subscribe((response: any) => {
					this.showLoad = false;
					if (response.success) {
						this.campaignsList.map((campaignItem) => {
							campaignItem.data = response.data.filter((obj) => obj.campaign_id === campaignItem.campaign_id);
						});
					} else {
						this.campaignsList = [];
					}
					this.processResponseData();
					this.getDisplayIndex = 0;
					this.campaignCarouselItem = this.campaignsList[0];
				});
		});
	}

	processResponseData() {
		this.campaignsList = this.campaignsList.map((campaignItem, index) => {
			const campaign = {
				name: campaignItem.campaign_name,
				id: campaignItem.campaign_id,
				average_lift: campaignItem.average_lift,
				average_baseline: campaignItem.average_baseline,
				average_exposed_rate: campaignItem.average_conversion_rate,
				baseline_data: [],
				exposed_rate: [],
				lift_data: [],
				categories: []
			};
			const baseline_data = [];
			const exposed_rate = [];
			const lift_data = [];

			const categories = [];
			campaignItem.data.forEach((dataObj) => {
				baseline_data.push(
					UtilityService.isUndefinedOrNull(Number(dataObj.average_baseline)) || Number(dataObj.average_baseline) == 0
						? '<0.01'
						: dataObj.average_baseline
				);
				exposed_rate.push(
					UtilityService.isUndefinedOrNull(Number(dataObj.average_conversion_rate)) ||
						Number(dataObj.average_conversion_rate) == 0
						? '<0.01'
						: Number(dataObj.average_conversion_rate)
				);
				lift_data.push(this.buildLiftDataObject(dataObj));
				categories.push(dataObj.impression_date);
			});
			campaign.baseline_data = baseline_data;
			campaign.exposed_rate = exposed_rate;
			campaign.lift_data = lift_data;
			campaign.categories = categories;
			return campaign;
		});
	}

	protected buildLiftDataObject(dataObject: any) {
		const liftTempObj: any = {};
		if (Number(dataObject.average_lift) > 99) {
			liftTempObj.y = 99;
			liftTempObj.displayLift = '>99';
		} else {
			liftTempObj.y = Number(dataObject.average_lift);
			liftTempObj.displayLift = dataObject.average_lift;
		}
		return liftTempObj;
	}

	prevArrow() {
		if (this.campaignsList.length > 1) {
			if (0 === this.getDisplayIndex) {
				this.getDisplayIndex = this.campaignsList.length - 1;
			} else {
				this.getDisplayIndex = this.getDisplayIndex - 1;
			}
			this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
		}
	}

	nextArrow() {
		if (this.campaignsList.length > 1) {
			if (this.campaignsList.length - 1 === this.getDisplayIndex) {
				this.getDisplayIndex = 0;
			} else {
				this.getDisplayIndex = this.getDisplayIndex + 1;
			}
			this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
		}
	}
}
